<template>
  <div class="notification-list">
    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

        <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
          <v-toolbar-title  class="hidden-md-and-down">
              <h2><v-icon large class="mr-2">mdi-bell</v-icon>{{$t('administration.notification.notifications')}}</h2>
          </v-toolbar-title>
          <v-spacer />
          <div>
            <v-btn
              class="ml-2"
              color="primary"
              @click="viewall"
            >
              {{ $t('administration.notification.viewall')}}
            </v-btn>
          </div>
        </v-toolbar>
        <div>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
              <template slot="item.type.type" slot-scope="{ item }">

                <v-icon v-if="item.view" >{{ icon(item.type.type) }}</v-icon>
                <v-icon color="primary" v-else>{{ icon(item.type.type) }}</v-icon>
              </template>
              <template slot="item.date" slot-scope="{ item }">

                  <strong v-if="item.view == false">{{ formatDateTime(item['date'], 'long') }}</strong>
                  <span v-else>{{ formatDateTime(item['date'], 'long') }}</span>
              </template>
              <template slot="item.data" slot-scope="{ item }">
                <strong v-if="item.view == false" >
                  <span class="d-none d-sm-flex">{{ $t(item.type.name, item.data) }}</span>
                  <span class="d-flex d-sm-none">...</span>
                </strong>
                <span v-else>
                  <span class="d-none d-sm-flex">{{ $t(item.type.name, item.data) }}</span>
                  <span class="d-flex d-sm-none">...</span>
                </span>

              </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </div>

      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';

export default {
  name: 'NotificationList',
  servicePrefix: 'Notification',
  mixins: [ListMixin],
  components: {
    ActionCell,
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.type'), value: 'type.type' , width: 80 },
        { text: this.$t('global.date'), value: 'date' },
        { text: this.$t('global.content'), value: 'data' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('notificationuser', {
      items: 'list'
    }),
    ...mapFields('notificationuser', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('notificationuser', {
      getPage: 'fetchAll',
      deleteItem: 'del',
      notificationuserPushAction: 'action'
    }),
    icon(type) {
      if (type == 'security') return 'mdi-security';
      if (type == 'machine') return 'mdi-printer-3d';
      if (type == 'toolhead') return 'mdi-tools';
      if (type == 'materialsupply') return 'mdi-format-color-fill';
      if (type == 'industrialcomputer') return 'mdi-server';
      if (type == 'operatingsystem') return 'mdi-microsoft-windows';
      if (type == 'printingsurface') return 'mdi-checkerboard';
      if (type == 'controlunit') return 'mdi-car-cruise-control';
      if (type == 'accessory') return 'mdi-cctv';
      return 'mdi-bell';
    },
    viewall() {
      this.notificationuserPushAction({action: 'viewall',values: {}});
    },
    updatedviewall(actioned) {
      console.log("updatedviewall");
      this.showMessage(actioned.message);
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      if (this.action == 'viewall') {
        this.updatedviewall(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
